import { MutationTuple, gql, useMutation } from '@apollo/client';
import { UserRegistrationInput } from '@cnx-saas/common';

const COMPLETE_REGISTRATION_MUTATION = gql`
  mutation completeRegistration($details: ApiRegistrationInput!) {
    completeRegistration(details: $details) {
      message
    }
  }
`;

interface CompleteRegistrationInput {
  details: UserRegistrationInput & {
    password: string;
    hasAcceptAgreement: boolean;
  };
}

interface CompleteRegistrationOutput {
  completeRegistration: {
    message: string;
  };
}

function useCompleteRegistrationMutation(): MutationTuple<
  CompleteRegistrationOutput,
  CompleteRegistrationInput
> {
  return useMutation<CompleteRegistrationOutput, CompleteRegistrationInput>(
    COMPLETE_REGISTRATION_MUTATION,
  );
}

export type { CompleteRegistrationOutput };
export { useCompleteRegistrationMutation };
